import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

const gap = '250px';

export const styles = css`
  width: 100%;
  height: 717px;

  ${breakpoints.only.desktop} {
    height: 633px;
  }

  ${breakpoints.only.tablet} {
    height: 600px;
  }

  ${breakpoints.to.desktop} {
    *[class*='balloon'] {
      display: none;
    }
  }

  ${breakpoints.only.mobile} {
    height: calc(100vh - ${gap});
  }
`;
